import { render, staticRenderFns } from "./ContentBlockJobs.vue?vue&type=template&id=eae5fe42&scoped=true"
import script from "./ContentBlockJobs.js?vue&type=script&lang=js&external"
export * from "./ContentBlockJobs.js?vue&type=script&lang=js&external"
import style0 from "./ContentBlockJobs.scss?vue&type=style&index=0&id=eae5fe42&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae5fe42",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Image/Image.vue').default,HotTitle: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Title/Title.vue').default,HotContainer: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Templates/Container/Container.vue').default})
